import React, { memo } from 'react';
import styles from './titleH2.module.scss';

export const TitleH2 = memo(({children}) => {

  return (
		<div className={styles.title_wrap}>
				<h2 className={styles.title}>{children}</h2>
		</div>
  );
});
